import analytics from '@utils/analytics';
import api from '@utils/api';
import React, { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import ArticleThumbnail from './ArticleThumbnail';
import Filters from './Filters';
import { appPostStructuredMessage } from '@common/utils/appUtils';
let firstShow = true;
const Portal = () => {
    const { t } = useTranslation();
    const urlParams = new URLSearchParams(location.search);
    const [articles, setArticles] = useState();
    const [filters, setFilters] = useState();
    const [category, setCategory] = useState(urlParams.get('category') || '');
    const [year, setYear] = useState(urlParams.get('year') || '');
    const [month, setMonth] = useState(urlParams.get('month') || '');
    const [hasMore, setHasMore] = useState(false);
    const [firstNewResultIndex, setFirstNewResultIndex] = useState();
    const [currentPage, setCurrentPage] = useState(parseFloat(urlParams.get('p') || '1'));
    const nextPage = currentPage + 1;
    /**
     *
     * @param loadMore - if true then new articles need to be added (load more)
     */
    const loadArticles = (loadMore) => {
        //empty month if user select ALL_YEAR
        const replaceMonth = month === t('monclernow.allyear') ? '' : month;
        const page = loadMore ? nextPage : 1;
        api.getMonclerNowData(category, year, replaceMonth, page).then((data) => {
            var _a;
            if (loadMore) {
                setArticles([...articles, ...data.contents]);
                let firstResult = data.contents[0].title;
                const focusedElement = document.querySelectorAll('.info-wrapper__title');
                focusedElement.forEach((el) => {
                    if (firstResult === el.innerHTML) {
                        el.closest('a').focus();
                    }
                });
            }
            else {
                setArticles(data.contents);
            }
            setFilters(data.refinement);
            setCurrentPage(data.currentPage);
            setHasMore(data.hasMore);
            setCurrentPage(page);
            setFirstNewResultIndex(data.contents.length);
            if (firstShow) {
                firstShow = false;
                const monclerNowListing = document.querySelector('.monclernow-listing');
                const newsletterModule = document.querySelector('.newsletter-module');
                if (newsletterModule) {
                    const articles = monclerNowListing.querySelectorAll('.monclernow-listing__article');
                    const position = Math.floor(articles.length / 4) * 4;
                    (_a = articles[position]) === null || _a === void 0 ? void 0 : _a.insertAdjacentElement('afterend', newsletterModule);
                    newsletterModule.style.opacity = '1';
                }
            }
        });
    };
    //remove category filter when user change year
    const updateYear = (year) => {
        setCategory('');
        setYear(year);
    };
    //reload articles when category or month filter are used
    useEffect(() => {
        //if category and month are empty prevent reload
        if (category === '' && year !== '' && month === '')
            return;
        loadArticles();
    }, [category, month]);
    //load more articles
    const loadMore = (e) => {
        e.preventDefault();
        analytics.loadMoreStories();
        loadArticles(true);
        if (window.appmode) {
            appPostStructuredMessage('firebase_analytics', {
                event: 'moncler_now_interactions',
                params: {
                    Action: 'moncler now-more_stories-undefined',
                    pageDetail: 'monclernow',
                },
            });
        }
    };
    const articlesSorted = useMemo(() => (articles && articles.length > 0 ? articles.sort((a, b) => (parseFloat(a.position) < parseFloat(b.position) ? -1 : 1)) : []), [articles]);
    // const nextPageUrl = currentPage ? updateURLParameter(location.href, 'page', String(nextPage)) : undefined;
    return (React.createElement(React.Fragment, null,
        React.createElement(Filters, { year: year, month: month, setYear: updateYear, setMonth: (month) => {
                analytics.filterArticles('date');
                setMonth(month);
            }, setCategory: (category) => {
                analytics.filterArticles(category);
                setCategory(category);
            }, filters: filters, categoryActive: category }),
        React.createElement("div", { id: "monclernow-tab", role: "tabpanel", className: "monclernow-tabpanel" },
            React.createElement("ul", { className: "monclernow-listing" }, articlesSorted.map((article, index) => (React.createElement(ArticleThumbnail, { landscape: index === 0 || article.landscape, key: index, article: article })))),
            hasMore && (React.createElement("div", { className: "monclernow-listing__btn-row" },
                React.createElement("button", { className: "button button--tertiary button--arrow-down", onClick: loadMore },
                    React.createElement("span", null, t('monclernow.loadmorestories'))))))));
};
export default Portal;
